module.exports = __webpack_public_path__ + "img/1696321715609-WhatsApp Image 2023-10-03 at 16.27.54.jpeg.5102b13c.webp";